import React from 'react';
import ReactDOM from 'react-dom';

export default {
    createClass: function(chartType, methodNames, dataKey) {
        let extras = ['clear', 'stop', 'resize', 'toBase64Image', 'generateLegend', 'update', 'addData', 'removeData'];
        
        class ChartClass extends React.Component {
            displayName = chartType + 'Chart';
            state = {};
            
            componentDidMount() {
                this.initializeChart(this.props);
            }

            componentWillReceiveProps(nextProps) {
                let chart = this.state.chart;
                if (nextProps.redraw) {
                    chart.destroy();
                    this.initializeChart(nextProps);
                } else {
                    dataKey = dataKey || dataKeys[chart.name];
                    updatePoints(nextProps, chart, dataKey);
                    if (chart.scale) {
                        chart.scale.xLabels = nextProps.data.labels;
                        chart.scale.calculateXLabelRotation();
                    }
                    chart.update();
                }
            }

            componentWillUnmount() {
                let chart = this.state.chart;
                chart && chart.destroy();
            }

            initializeChart = (nextProps) => {
                let Chart = require('chart.js');
                let el = ReactDOM.findDOMNode(this);
                let ctx = el.getContext("2d");
                let chart = new Chart(ctx)[chartType](nextProps.data, nextProps.options || {});
                this.setState({chart});
            };
            
            render() {
                let _props = {
                    ref: 'canvass'
                };
                for (let name in this.props) {
                    if (this.props.hasOwnProperty(name)) {
                        if (name !== 'data' && name !== 'options') {
                            _props[name] = this.props[name];
                        }
                    }
                }
                return <canvas {..._props} />;
            }
        }

        let i;
        for (i=0; i<extras.length; i++) {
            extra(extras[i]);
        }
        for (i=0; i<methodNames.length; i++) {
            extra(methodNames[i]);
        }

        function extra(type) {
            ChartClass.prototype[type] = function() {
                return this.state.chart[type].apply(this.state.chart, arguments);
            };
        }
        
        return ChartClass;
    }

};

let dataKeys = {
    'Line': 'points',
    'Radar': 'points',
    'Bar': 'bars'
};

let updatePoints = function(nextProps, chart, dataKey) {
    let name = chart.name;

    if (name === 'PolarArea' || name === 'Pie' || name === 'Doughnut') {
        nextProps.data.forEach(function(segment, segmentIndex) {
            if (!chart.segments[segmentIndex]) {
                chart.addData(segment);
            } else {
                Object.keys(segment).forEach(function (key) {
                    chart.segments[segmentIndex][key] = segment[key];
                });
            }
        });
    } else {
        while (chart.scale.xLabels.length > nextProps.data.labels.length) {
            chart.removeData();
        }
        nextProps.data.datasets.forEach(function(set, setIndex) {
            set.data.forEach(function(val, pointIndex) {
                if(chart.datasets[setIndex][dataKey]){ //HOTFIX: rendering LineBar next to Bar gives errors
                    if (typeof(chart.datasets[setIndex][dataKey][pointIndex]) == "undefined") {
                        addData(nextProps, chart, setIndex, pointIndex);
                    } else {
                        chart.datasets[setIndex][dataKey][pointIndex].value = val;
                    }
                }
            });
        });
    }
};

let addData = function(nextProps, chart, setIndex, pointIndex) {
    let values = [];
    nextProps.data.datasets.forEach(function(set) {
        values.push(set.data[pointIndex]);
    });
    chart.addData(values, nextProps.data.labels[setIndex]);
};
